import * as React from "react"
import { Button as ShadcnButton } from "@/components/ui/button"
import type { ButtonProps as ShadcnButtonProps } from "@/components/ui/button"

/**
 * Extended Button component wrapping shadcn/ui Button
 * Provides consistent button styling across the application
 */
export interface ButtonProps extends ShadcnButtonProps {
  /** Whether the button is in a loading state */
  loading?: boolean
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, loading, disabled, ...props }, ref) => {
    return (
      <ShadcnButton
        ref={ref}
        disabled={disabled || loading}
        {...props}
      >
        {loading ? (
          <span className="flex items-center gap-2">
            <span className="animate-spin">⏳</span>
            {children}
          </span>
        ) : (
          children
        )}
      </ShadcnButton>
    )
  }
)

Button.displayName = "Button"
